import { Box, Button, Typography } from "@mui/material";
interface MicrosoftLoginButtonProps {
  onClick: () => void;
  isDisabled: boolean;
}

const MicrosoftLoginButton = ({
  onClick,
  isDisabled,
}: MicrosoftLoginButtonProps) => {
  return (
    <Button
      sx={{
        px: 0,
        textTransform: "none",
        color: "unset",
        borderRadius: 0,
        height: 50,
        width: "100%",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        border: "1px solid #8C8C8C",
        backgroundColor: "#FFFFFF",
        cursor: "pointer",
        userSelect: "none",
        transition:
          "background-color 0.218s, border-color 0.218s, box-shadow 0.218s",
        boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
        boxSizing: "border-box",
        "&:hover": {
          backgroundColor: "#F3F3F3",
          borderColor: "#6C6C6C",
          boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.2)",
        },

        "&:active": {
          backgroundColor: "#E5E5E5",
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.1)",
        },
      }}
      onClick={onClick}
      disabled={isDisabled}
    >
      <img
        style={{ height: 48, width: 48, background: "white" }}
        src="./buttonIcon/microsoftIcon.png"
        alt="Microsoft Logo"
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          backgroundColor: "#FFFFFF",
          cursor: "pointer",
        }}
      >
        <Typography
          sx={{
            fontFamily: "Roboto, Arial, sans-serif",
            fontSize: "16px",
            lineHeight: "48px",
            width: "100%",
          }}
        >
          Sign in with Microsoft
        </Typography>
      </Box>
    </Button>
  );
};

export default MicrosoftLoginButton;
